import { AxiosError, type AxiosResponse, HttpStatusCode } from 'axios';
import { client } from '@/api/http';
import { getIdFromUrl } from '@/api/getIdFromUrl';

export async function createHipSpineStudy(caseId: number): Promise<string> {
    const { status, data, headers }: AxiosResponse = await client.post(
        `/cases/${caseId}/hip-spine-studies`,
    );
    if (status === HttpStatusCode.Created) {
        return data?.id ?? getIdFromUrl(headers.location);
    }

    throw new AxiosError(`Failed to create study: ${data?.detail}`);
}

export async function startHipSpineStudyProcess(
    caseId: number,
    hipSpineStudyId: number | string,
    webComponentVersion: string,
): Promise<void> {
    const { status, data }: AxiosResponse = await client.post(
        `/cases/${caseId}/hip-spine-studies/${hipSpineStudyId}/process`,
        { web_component_version: webComponentVersion },
        /**
         * This request might take a while to complete in the server side, so we need to increase the timeout
         * The backend publishes a job to the queue and waits until the message was acknowledged by the queue, but
         * during period of high load this takes a while.
         */
        { timeout: 60 * 1000 },
    );
    if (status === HttpStatusCode.Accepted) {
        return;
    }
    throw new AxiosError(`Failed to start hip spine study process: ${data?.detail}`);
}
